module.exports = "/images/businessLogo.webp?1184d2cfd40a0104d732dbb2ebfa348b";